import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  getLocations,
  removeLocation as remove,
  addLocation as add,
  modifyLocation as modify,
  updateLocations,
} from 'locations/actions';
import { addGrowlSuccess as success, addGrowlError as error } from 'messages/actions';

import { getVisibleLocations } from 'locations/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';
import { valueFromEvent, createRoute } from 'lib/util';
import { withRouter } from 'react-router-dom';

class LocationsTreeHandlers extends Component {
  static propTypes = { render: PropTypes.func.isRequired };

  handleAddLocation = (location) => this.props.add(location ? location.id : null);

  handleRemoveLocation = (location) => {
    // console.table(location);
    // this.props.modify(location.id, { ...location , deleted: true });
    // console.table(location)
    this.props.remove(location.id);
  };

  handleValueChange = (location, e) => this.props.modify(location.id, valueFromEvent(e));

  HasChildsWithSameName = (locations) => {
    // Funcion recursiva para validar que no existan ubicaciones con el mismo nombre y en el mismo nivel.
    let repetidos = { response: false, same: [] };
    let namesArray = []; //Arreglo sobre el mismo nivel con las ubicaciones

    locations.forEach((location) => {
      // Se analiza cada ubicacion del arreglo (childs)
      if (!location.deleted) {
        // No analizar si la ubicacion esta eliminada
        if (location._childs.length > 1) {
          // En caso de que una ubicacion del arreglo (childs) contenga 2 o mas hijos
          let res = this.HasChildsWithSameName(location._childs); // llamado recursivo a la funcion mandando los childs
          if (res.response) repetidos = res; // solo en caso de que si se encuentren hijos similares copiar la respuesta, para evitar ignorar a los repetidos en niveles superiores.
        }

        if (namesArray.includes(location.name)) {
          // Si encuentra un nombre repetido
          repetidos.response = true; // respuesta true
          repetidos.same.push(location.name); // y agrega el nombre del repetido a la lista de repetidos
        }
        namesArray.push(location.name); // Asi mismo siempre agrega el nombre del nodo a la lista de ubicaciones.
      }
    });

    return repetidos;
  };

  handleSubmit = () => {
    const hasChildsSameName = this.HasChildsWithSameName(this.props.locations);
    if (hasChildsSameName.response) {
      console.log('Hijo con nombre repetido');
      let respuesta = 'No puede haber 2 nodos con el mismo nombre\n';
      hasChildsSameName.same.forEach((location) => {
        respuesta += location + '\n';
      });
      this.props.error(respuesta);
    } else {
      console.log('Ningun hijo con nombre repetido');
      this.props
        .updateLocations(this.props.company.id, this.props.subcompany.id, this.props.locations)
        .then(({ value }) => {
          this.props.success(value.message);
          this.props.history.push(
            createRoute(this.props.company.id, this.props.subcompany.id, 'locations')
          );
        })
        .catch((err) => this.props.error(err.message))
        .finally(() => {
          this.componentWillMount = this.props.getLocations(
            this.props.company.id,
            this.props.subcompany.id
          );
        });
    }
  };

  componentWillMount = this.props.getLocations(this.props.company.id, this.props.subcompany.id);

  render = () =>
    this.props.render({
      handleAddLocation: this.handleAddLocation,
      handleRemoveLocation: this.handleRemoveLocation,
      handleValueChange: this.handleValueChange,
      handleSubmit: this.handleSubmit,
    });
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  locations: getVisibleLocations(state),
});

const mapDispatchToProps = { getLocations, remove, add, modify, updateLocations, success, error };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LocationsTreeHandlers));



// WEBPACK FOOTER //
// src/modules/secured/modules/locations/containers/LocationsTreeHandlers.js